<div class="appContentsContainer">
  <div class="backgroundSand container fullWidthContainer listPage">
    <h2>{{ "printsRules.titleList" | translate }}</h2>
    <div class="filterTableContainer">
      <app-filters
        #insideTable
        [filterList]="filterList"
        [ngClass]="{ filterHidden: !showTableFilter }"
        [options]="optionsheader"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-table
        [tableList]="tableList"
        [elementList]="printsRules"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (elementsToRemove)="removeElements($event)"
        (moveUpDown)="moveUpDown($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
      ></app-table>
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </div>
</div>
